import { useEffect, useState } from "react";
// import Navbar from "../../components/navbar/Navbar";
// import Footer from "../../components/footer/Footer";
// import Header from "../../components/header/Header";
import dailyCampaign from "../../assets/images/dailyCampaign.svg";
import { getRandomColor } from "../../utils/colors.tsx";
import { getFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';


const DailyCampaigns = () => {
    const [campaignsData, setCampaignsData] = useState<any[]>([]);

    const navigate = useNavigate();

    // get all daily campaigns
    useEffect(() => {
        const getDailyCampaigns = async () => {
            try {
                const response = await getFetcher(endpoints.campaigns.dailyCampaigns);

                if (response) {
                    // Sort by date to move the most recent additions to the top
                    const sortedCampaigns = response.dailyCampaigns.sort(
                        (a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
                    );
                    setCampaignsData(sortedCampaigns);
                } else {
                    toast.error('Error');
                    setTimeout(() => {
                        navigate("/")
                    }, 700);
                }
            } catch (error) {
                toast.error('Error');
            }
        };
        getDailyCampaigns();
    }, []);



    return (
        <div className="flex flex-col min-h-screen">
            {/* <Header />
            <Navbar /> */}
            <main className="flex-grow p-6 mb-20">
                <div className="max-w-7xl mx-auto bg-white rounded-lg ">
                    {/* HEADER */}
                    <div className="lg:pl-16">
                        <img src={dailyCampaign} alt="dailyCampaign" className="" />
                    </div>

                    {/* CARDS */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 ">
                        {campaignsData.map((campaign, index) => {
                            const images = (campaign.product?.images || '[]');
                            return (
                                <div key={index}
                                    onClick={() => navigate(`/daily-campaign/${campaign.id}`)}
                                    className={`rounded-2xl shadow-md flex lg:gap-8 gap-4 m-5 ${getRandomColor()} relative hover:shadow-2xl transition-all cursor-pointer`}>
                                    {images.length > 0 && (
                                        <img src={images[0]} alt={campaign.product.name}
                                            className="lg:w-3/5 w-1/2 h-48 object-cover rounded-2xl" />
                                    )}
                                    <div className="p-4 flex flex-col justify-center flex-grow space-y-2 lg:w-2/5 w-1/2">
                                        <p className="text-xl lg:text-3xl text-white font-semibold">{campaign.title}</p>
                                    </div>
                                    <div className="  absolute -left-14 -top-3 text-white h-8 hidden md:flex justify-center items-center bg-primary-color opacity-70 px-3 py-5 rounded-2xl">
                                        {campaign.supplier.marketPlaceName}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </main>
            {/* <Footer /> */}
        </div>
    );
};

export default DailyCampaigns;